import ServicePageTemplate from "@/components/layout/ServicePageTemplate";

export default function RoofingPage() {
  return (
    <div data-testid="roofing-page">
      <ServicePageTemplate
        overline="Roofing"
        title="Roofing that holds up to LA sun, wind and storms."
        sub="From small repairs to complete re-roofs, our crews install clean, code-compliant roofs with quality materials and warranty-backed workmanship."
        image="https://images.pexels.com/photos/5025639/pexels-photo-5025639.jpeg"
        serviceTitle="Roofing"
        services={[
          "Roof Repairs",
          "Full Re-Roof / Tear-Off",
          "Asphalt Shingle Installation",
          "Tile Roof Installation",
          "Flat & Low-Slope Roofing",
          "Leak Detection & Repair",
          "Roof Inspections",
          "Gutter Installation & Repair",
          "Skylight Installation",
          "Storm Damage Repair",
        ]}
        benefits={[
          "Quality Roofing Materials",
          "Warranty-Backed Installs",
          "Licensed Roofing Crews",
          "Clean Tear-Off & Haul-Away",
          "Insurance Claim Support",
          "Residential & Commercial",
        ]}
        faq={[
          { q: "How long does a re-roof take?", a: "Most single-family re-roofs are done in 2–4 days depending on size, material and weather." },
          { q: "Do you offer roof inspections?", a: "Yes — we provide free roof inspections and detailed condition reports before any work begins." },
          { q: "Can you work with my insurance?", a: "Absolutely. We document storm and impact damage and can coordinate with adjusters when needed." },
        ]}
      />
    </div>
  );
}
